import TicketTypeRoutes from '@/modules/ticket-type/routes'
import TicketDepartments from '@/modules/ticket-department/routes'
import TicketPriorities from '@/modules/ticket-priority/routes'
import TicketTemplates from '@/modules/ticket-template/routes'
// import DatumDefinition from '@/views/system/datum-definition/routes'
import Collectors from '@/views/system/collector/routes'
import DocumentTemplates from '@/views/system/document-template/routes'
import CategoryRoutes from '@/views/system/category/routes'
import BankFeedSourcesRoutes from '@/views/system/bank-feed-source/routes'
import CountryRoutes from '@/views/system/country/routes'
import FNNRoutes from '@/views/system/fnn/routes'
import GroupRoutes from '@/views/system/groups/routes'
import IPRoutes from '@/views/system/ip/routes'
import LinkRoutes from '@/views/system/link/routes'
import RssRoutes from '@/views/system/rss/routes'
import SecretRoutes from '@/views/system/secrets/routes'
import EmailTemplateRoutes from '@/views/system/template/email/routes'
import CustomerTypeRoutes from '@/views/system/customer/type/routes'
import RegionRoutes from '@/views/system/region/routes'
import ArticleTagRoutes from '@/views/system/article-tag/routes'
import ArticleCategoryRoutes from '@/views/system/article-category/routes'
import ArticleListTagRoutes from '@/views/system/article-list-tag/routes'

export enum CustomerSiteTypeRouteName {
    Index = 'system.customer.site.types.index',
    Create = 'system.customer.site.types.create',
    Edit = 'system.customer.site.types.edit',
}

export enum JSONUIRouteName {
    Index = 'system.jsonui.index',
}

export enum SentEmailRouteName {
    Index = 'system.sent-emails.index',
}

export default {
    path: '/system',
    name: 'system',
    component: () => import('@/views/system/Index.vue'),
    meta: {
        auth: true,
        label: 'System',
        location: 'sidebar-bottom',
        icon: 'fal fa-server fa-fw',
        group: 'main',
        children: false,
    },
    children: [
        ArticleCategoryRoutes,
        ArticleListTagRoutes,
        ArticleTagRoutes,
        BankFeedSourcesRoutes,
        CategoryRoutes,
        CountryRoutes,
        EmailTemplateRoutes,
        FNNRoutes,
        GroupRoutes,
        IPRoutes,
        LinkRoutes,
        CustomerTypeRoutes,
        {
            path: 'customer/site/types',
            name: CustomerSiteTypeRouteName.Index,
            component: () => import('@/views/system/customer/site/type/Index.vue'),
            meta: {
                auth: true,
                label: 'Customer Site Types',
                icon: 'fal fa-map-marker-alt fa-fw',
                group: 'main',
                location: 'sidebar',
                permission: 'manage-customer-site-types',
            },
            children: [
                {
                    path: 'create',
                    name: CustomerSiteTypeRouteName.Create,
                    component: () => import('@/views/system/customer/site/type/Index.vue'),
                    meta: {
                        auth: true,
                        label: 'Create Customer Site Types',
                        group: 'main',
                        permission: 'manage-customer-site-types',
                    },
                },
                {
                    path: ':customerSiteTypeId/edit',
                    name: CustomerSiteTypeRouteName.Edit,
                    component: () => import('@/views/system/customer/site/type/Index.vue'),
                    meta: {
                        auth: true,
                        label: 'Edit Customer Site Types',
                        group: 'main',
                        permission: 'manage-customer-site-types',
                    },
                },
            ],
        },
        {
            path: 'jsonui',
            name: JSONUIRouteName.Index,
            component: () => import('@/views/system/jsonui/Index.vue'),
            meta: {
                auth: true,
                label: 'JSONUI',
                icon: 'fal fa-cart-plus fa-fw',
                group: 'main',
                location: 'sidebar',
                permission: 'manage-collectors',
            },
        },
        RegionRoutes,
        SecretRoutes,
        RssRoutes,
        TicketTypeRoutes,
        TicketDepartments,
        TicketPriorities,
        TicketTemplates,
        // DatumDefinition,
        Collectors,
        DocumentTemplates,
    ],
}
